import React, { useState, useRef, useCallback } from 'react';
import { useSpring, animated, config } from '@react-spring/web';
import type { SpringConfig } from '@react-spring/web';
import { useOnceOnScreen } from '../hooks/useOnceOnScreen';

interface AnimatedNumberProps {
  from?: number;
  to: number;
  valueFormatter?: (num: number) => string;
  /**
   * in milliseconds
   */
  animationDelay?: number;
  springConfig?: SpringConfig;
  className?: string;
  style?: React.CSSProperties;
}

export const AnimatedNumber = ({
  from = 0,
  to,
  animationDelay = 100,
  valueFormatter = (num: number) => num.toString(),
  springConfig = config.default,
  className,
  style,
}: AnimatedNumberProps) => {
  const [hasBeenTriggered, setHasBeenTriggered] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);
  const onceOnScreen = useCallback(() => setHasBeenTriggered(true), []);

  useOnceOnScreen(ref, onceOnScreen);

  const { number } = useSpring({
    from: { number: from }, // start number
    number: to, // end number
    delay: animationDelay,
    pause: !hasBeenTriggered,
    config: springConfig,
  });

  return (
    <animated.span className={className} style={style} ref={ref}>
      {number.to(valueFormatter)}
    </animated.span>
  );
};
